import { Role } from '@/api/RoleApi';
import { BaseEntity } from '@/api/EntityApi';
import { Company } from '@/api/CompanyApi';

export enum UserStatus {
	INACTIVE = 'INACTIVE',
	ACTIVE = 'ACTIVE',
	SUSPENDED = 'SUSPENDED',
}

export enum UserType {
	ADMIN = 'admin',
	USER = 'user',
}

export enum UserAccessLevel {
	LEVEL_0 = 'level_0',
	LEVEL_1 = 'level_1',
	LEVEL_2 = 'level_2',
}

interface BaseUser extends BaseEntity {
	email: string;
	phoneNumber: string;
	firstName: string;
	lastName: string;
	password: string;
	status: UserStatus;
	userType: UserType;
}

export interface Admin extends BaseUser {
	role: Role;
	userType: UserType.ADMIN;
}

export interface User extends BaseUser {
	accessLevel: UserAccessLevel;
	company: Company;
	userType: UserType.USER;
}

export type AppUser = Admin;
